// extracted by mini-css-extract-plugin
module.exports = {"recommender":"Sc-z"};